import { render, staticRenderFns } from "./edit-organization-overlay.vue?vue&type=template&id=29d6fd2e"
import script from "./edit-organization-overlay.vue?vue&type=script&lang=js"
export * from "./edit-organization-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports